define('lib/validator/ValidatorAbstract',['require','marionette'],function (require) {

	var Marionette = require('marionette');
	
	return Marionette.Object.extend({
        
        options: {},
		
		initialize : function (options) {
            Marionette.Object.prototype.initialize.apply(this, arguments);
            
            this.options = _.extend(this.options, options);
        },
		
		_errors: [],
		
		/**
		 * Validates value and returns true/false
		 * 
		 * @param mixed value
		 * @return Boolean
		 */
		isValid: function (value) {
			this._errors = [];
			this.validate(value);
			if (this._errors.length) {
				return false;
			}
			return true;
		},
	
		/**
		 * Here you should implemen validation logic and 
		 * add errors to _errors via addError
		 * 
		 * @param mixed value
		 */
		validate: function (value) {
		},
		
		/**
		 * Adds error to _errors
		 * 
		 * @param String error
		 */
		addError: function (error) {
			//console.trace(1);
			this._errors.push(error);
		},
		
		/**
		 * Returns errors list
		 * 
		 * @return Array
		 */
		getErrors: function () {
			return this._errors;
		}
		
	});
	
});
